import { UnserviceableStatu, UnserviceableStatuText } from "./UnserviceableStatus";
import { ServiceableStatu, ServiceableStatuText } from "./ServiceableStatus";
import { RequestType } from "./RequestType";
import { RequestStatus } from "./RequestStatus";
import { RequestOrderTabEnum } from "./RequestOrderTabEnum";
import { RequestFileType } from "./RequestFileType";
import { RemoveReasonType, GetRemoveReasonType } from "./RemoveReasonType";
import { RemarkTypes } from "./RemarkTypes";
import { PhaseInOutStatus } from "./Phase";
import { CarrierType, GetCarrierType } from "./CarrierType";
import { ActivePassiveStatus } from "./Active";
import { RequestListGroupType } from "./RequestListGroupType";
import { RequestExcusableType } from "./RequestExcusableType";
import { RequestExcusableStatus } from "./RequestExcusableStatus";
import { RequestExcusableShippingType } from "./RequestExcusableShippingType";
import { AbilityLimitStatus } from "./AbilityLimitStatus";
import { RoleType } from "./RoleType";
import { QuarantineReasons } from "./QuarantineReasons";
import { QuarantineAssignedGroup } from "./QuarantineAssignedGroup";
import { QuarantineStatusType } from "./QuarantineStatusType";
import { HomebaseStatusType } from "./HomebaseStatusType";
import { PbhRequestStatus } from "./PbhRequestStatus";
import { PbhRequestedInfoType } from "./PbhRequestedInfoType";
import { WaitingResponseType } from "./WaitingResponseType";
import { CoreInfoRequestReasonTypeEnum, GetCoreInfoRequestReasonTypeEnum } from "./CoreInfoRequestReasonTypeEnum";
import { CoreInfoRequestStatusEnum } from "./CoreInfoRequestStatusEnum";
import { ReliabilityReportType } from "./ReliabilityReportType";
import { ReliabilityFofStatus } from "./ReliabilityFoFStatus";
import { ReliabilityReportStatus } from "./ReliabilityReportStatus";
import { ReliabilityFofReasonType } from "./ReliabilityFofReasonType";
import { StepType } from "./StepType";
import { ModuleType } from "./ModuleType";
import { RemovalTransactionType } from "./RemovalTransactionType";
import { ReliabilityPrematureFailureStatus } from "./ReliabilityPrematureFailureStatus";
import { ReliabilityPrematureFailureReasonType } from "./ReliabilityPrematureFailureReasonType";
import { ReliabilityRogueReasonType } from "./ReliabilityRogueReasonType";
import { ReliabilityRogueStatus } from "./ReliabilityRogueStatus";
import { ExperienceNoteType } from "./ExperienceNoteType";
import { PbhRequestFileType } from "./PbhRequestFileType";
export const enums = {
  CarrierType,
  ActivePassiveStatus,
  GetCarrierType,
  PhaseInOutStatus,
  RemarkTypes,
  GetRemoveReasonType,
  RemoveReasonType,
  RequestFileType,
  RequestOrderTabEnum,
  RequestStatus,
  RequestType,
  ServiceableStatu,
  ServiceableStatuText,
  UnserviceableStatu,
  UnserviceableStatuText,
  RequestListGroupType,
  RequestExcusableType,
  RequestExcusableStatus,
  RequestExcusableShippingType,
  AbilityLimitStatus,
  RoleType,
  QuarantineReasons,
  QuarantineAssignedGroup,
  QuarantineStatusType,
  HomebaseStatusType,
  PbhRequestStatus,
  PbhRequestedInfoType,
  WaitingResponseType,
  CoreInfoRequestReasonTypeEnum,
  GetCoreInfoRequestReasonTypeEnum,
  CoreInfoRequestStatusEnum,
  ReliabilityReportType,
  ReliabilityFofStatus,
  ReliabilityReportStatus,
  ReliabilityFofReasonType,
  StepType,
  ModuleType,
  RemovalTransactionType,
  ReliabilityPrematureFailureStatus,
  ReliabilityPrematureFailureReasonType,
  ReliabilityRogueStatus,
  ReliabilityRogueReasonType,
  ExperienceNoteType,
  PbhRequestFileType,
};
export default enums;
